// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useEffect, useRef, useState } from 'react';
import { useCookies } from 'react-cookie'; // Import useCookies from react-cookie
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Button from '../../components/buttons/Button';
import Header from '../../components/header/HeadingOne';
import Navbar from '../../layout/Navbar';
import ApiService from '../../services/ApiService';
import CustomSelect from './CustomSelect';
import Dropdown from './Dropdown';
import ModalContent from './ModalContent';
function MultiTransactions() {
  const [startDate, setStartDate] = useState<Date | null>();
  const [endDate, setEndDate] = useState<Date | null>();
  const [activeButton, setActiveButton] = useState<'today' | 'clear' | null>(
    null,
  );
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const [showStartCalendar, setShowStartCalendar] = useState<boolean>(false);
  const [showEndCalendar, setShowEndCalendar] = useState<boolean>(false);
  const [selectedPage, setSelectedPage] = useState<number>(1);
  const [lounges, setLounges] = useState<string[]>([]);
  const [selectedLounge, setSelectedLounge] = useState<string[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedReportType, setSelectedReportType] = useState<string | null>(
    null,
  );
  const reportTypes = [
    'Business Report',
    'Bank Report',
    'Redeem Voucher Report',
  ];
  const reportValues = {
    'Business Report': 'business',
    'Bank Report': 'bank',
    'Redeem Voucher Report': 'vouchers',
  };
  const inputOneRef = useRef<HTMLInputElement>(null);
  const inputTwoRef = useRef<HTMLInputElement>(null);
  const totalPages = 3;
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [showError, setShowError] = useState<string | null>(null);
  const [cookies] = useCookies(['role']); // Use cookies hook to access the "role" cookie
  dayjs.extend(utc);
  dayjs.extend(timezone);

  const handleToday = (value: 'start' | 'end') => {
    const today = new Date();
    if (value === 'start') {
      setStartDate(today);
      setActiveButton('today');
    } else {
      setEndDate(today);
      setActiveButton('today');
    }
  };

  const handleClear = (value: 'start' | 'end') => {
    if (value === 'start') {
      setStartDate(null);
      setActiveButton('clear');
    } else {
      setEndDate(null);
      setActiveButton('clear');
    }
  };

  const closeModal = (reset) => {
    if (reset) {
      setSelectedPage(1);
      setStartDate(null);
      setEndDate(null);
      setSelectedLounge([]);
    }
    setOpenModal(false);
  };
  const handleSelectedDateRange = async () => {
    if (!startDate || !endDate) return;

    // Validate date range
    if (dayjs(startDate).isAfter(dayjs(endDate))) {
      setShowError('Start date cannot be after end date.');
      return;
    }

    // Check if date range exceeds 31 days
    const daysDifference = dayjs(endDate).diff(dayjs(startDate), 'day') + 1;
    if (daysDifference > 31) {
      setShowError('Date range cannot exceed 31 days.');
      return;
    }

    setShowError(null);

    const startDateIST = dayjs(startDate)
      .tz('Asia/Kolkata')
      .startOf('day')
      .format('YYYY-MM-DDTHH:mm:ssZ');

    const endDateIST = dayjs(endDate)
      .tz('Asia/Kolkata')
      .endOf('day')
      .format('YYYY-MM-DDTHH:mm:ssZ');

    setStartDate(startDateIST);
    setEndDate(endDateIST);
    setSelectedPage(2);
  };

  const handleSelectedLounge = async () => {
    setSelectedPage(3);
  };
  const handleSelectedReportType = () => {
    setOpenModal(true);
  };

  const getLounges = async () => {
    const response = await ApiService.get('v1/lounge/');
    setLounges(response.data);
  };

  useEffect(() => {
    if (cookies.role === 'OfficeHead' || cookies.role === 'Admin') {
      getLounges();
    }

    const handleCalendarClickOutside = (event: MouseEvent) => {
      if (
        inputOneRef.current &&
        !inputOneRef.current.contains(event.target as Node)
      ) {
        setShowStartCalendar(false);
      }
      if (
        inputTwoRef.current &&
        !inputTwoRef.current.contains(event.target as Node)
      ) {
        setShowEndCalendar(false);
      }
    };
    document.addEventListener('mousedown', handleCalendarClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleCalendarClickOutside);
    };
  }, [cookies.role]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        // Stop event propagation to prevent interference with form submission
        event.stopPropagation();
        setIsDropdownOpen(false);
      }
    };

    // Use capture phase to ensure this runs before other click handlers
    document.addEventListener('mousedown', handleClickOutside, true);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside, true);
    };
  }, []);

  useEffect(() => {
    if (startDate && endDate) {
      const daysDifference = dayjs(endDate).diff(dayjs(startDate), 'day') + 1;
      if (daysDifference <= 31 && !dayjs(startDate).isAfter(dayjs(endDate))) {
        setShowError(null);
      } else {
        setShowError('Date range cannot exceed 31 days.');
        return;
      }
    }
  }, [startDate, endDate]);

  return (
    <div className="bg-lightBlue flex h-fit min-h-screen flex-col items-center overflow-x-hidden p-10 pb-4 xl:pt-20">
      <div className="flex w-full flex-col gap-9 2xl:w-[1040px]">
        <Navbar />
        {/* <Logo /> */}
        <Header />
        <hr className="w-full border-[0.5px] border-[#9CA3AF]" />
        {selectedPage === 1 && (
          <div className="flex flex-col gap-2">
            <div className="text-center text-2xl font-semibold text-[#1E429F] xl:text-3xl">
              Select time period
            </div>
            <div className="flex justify-center gap-4">
              <div ref={inputOneRef} className="flex flex-col">
                <input
                  type="text"
                  readOnly
                  value={startDate ? dayjs(startDate).format('DD-MM-YYYY') : ''}
                  onClick={() => {
                    setShowStartCalendar(!showStartCalendar);
                    setShowEndCalendar(false);
                  }}
                  placeholder="Start Date"
                  className="mt-4 w-72 cursor-pointer rounded-[8px] border border-[#D1D5DB] bg-[#F9FAFB] p-2 text-left font-inter leading-6 outline-none"
                />
                {showStartCalendar && (
                  <div className="mt-2">
                    <DatePicker
                      selected={startDate}
                      maxDate={endDate ? endDate : new Date()}
                      onChange={(date: Date | null) => {
                        setStartDate(date);
                        setShowStartCalendar(false);
                      }}
                      inline
                      dateFormat="dd-MM-yyyy"
                      calendarClassName="custom-multi-calendar"
                    >
                      <div className="mt-2 flex w-full justify-around">
                        <button
                          className={`w-[45%] rounded-lg px-4 py-2 ${
                            activeButton === 'today'
                              ? 'bg-[#1A56DB] text-white'
                              : 'border border-[#E5E7EB] text-gray-800'
                          }`}
                          onClick={() => handleToday('start')}
                        >
                          Today
                        </button>
                        <button
                          className={`w-[45%] rounded-lg px-4 py-2 ${
                            activeButton === 'clear'
                              ? 'bg-[#1A56DB] text-white'
                              : 'border border-[#E5E7EB] text-gray-800'
                          }`}
                          onClick={() => handleClear('start')}
                        >
                          Clear
                        </button>
                      </div>
                    </DatePicker>
                  </div>
                )}
              </div>

              <div ref={inputTwoRef} className="flex flex-col">
                <input
                  type="text"
                  readOnly
                  value={endDate ? dayjs(endDate).format('DD-MM-YYYY') : ''}
                  onClick={() => {
                    setShowEndCalendar(!showEndCalendar);
                    setShowStartCalendar(false);
                  }}
                  placeholder="End Date"
                  className="mt-4 w-72 cursor-pointer rounded-[8px] border border-[#D1D5DB] bg-[#F9FAFB] p-2 text-left font-inter leading-6 outline-none"
                />
                {showEndCalendar && (
                  <div className="mt-2">
                    <DatePicker
                      selected={endDate}
                      minDate={startDate ? startDate : null}
                      maxDate={
                        startDate
                          ? new Date(
                              Math.min(
                                new Date().getTime(),
                                dayjs(startDate)
                                  .add(30, 'day')
                                  .toDate()
                                  .getTime(),
                              ),
                            )
                          : new Date()
                      }
                      onChange={(date: Date | null) => {
                        setEndDate(date);
                        setShowEndCalendar(false);
                      }}
                      inline
                      dateFormat="dd-MM-yyyy"
                      calendarClassName="custom-multi-calendar"
                    >
                      <div className="mt-2 flex w-full justify-evenly">
                        <button
                          className={`w-[45%] rounded-lg px-4 py-2 ${
                            activeButton === 'today'
                              ? 'bg-[#1A56DB] text-white'
                              : 'border border-[#E5E7EB] text-gray-800'
                          }`}
                          onClick={() => handleToday('end')}
                        >
                          Today
                        </button>
                        <button
                          className={`w-[45%] rounded-lg px-4 py-2 ${
                            activeButton === 'clear'
                              ? 'bg-[#1A56DB] text-white'
                              : 'border border-[#E5E7EB] text-gray-800'
                          }`}
                          onClick={() => handleClear('end')}
                        >
                          Clear
                        </button>
                      </div>
                    </DatePicker>
                  </div>
                )}
              </div>
            </div>
            <div className="mt-4 flex w-1/2 flex-col gap-2 !place-self-center">
              {showError && (
                <p className="text-left text-sm text-red-600">{showError}</p>
              )}
              <Button
                disabled={!startDate || !endDate}
                buttonType="submit"
                text="Continue"
                className="!text-lg"
                onClick={handleSelectedDateRange}
              />
            </div>
          </div>
        )}
        {selectedPage === 2 && (
          <div className="flex flex-col items-center gap-6">
            <div className="flex w-full flex-col gap-4 2xl:gap-6">
              <div
                className="flex cursor-pointer justify-center text-center text-sm text-[#1C64F2] underline xl:text-base"
                onClick={() => setSelectedPage(1)}
              >
                <div>
                  Chosen time period -{' '}
                  {startDate ? dayjs(startDate).format('DD-MM-YYYY') : ''} to{' '}
                  {endDate ? dayjs(endDate).format('DD-MM-YYYY') : ''}
                </div>
                <div className="ml-2">
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.55 3.24001L4.70829 10.4817C4.44996 10.7567 4.19996 11.2983 4.14996 11.6733L3.84162 14.3733C3.73329 15.3483 4.43329 16.015 5.39996 15.8483L8.08329 15.39C8.45829 15.3233 8.98329 15.0483 9.24162 14.765L16.0833 7.52334C17.2666 6.27334 17.8 4.84834 15.9583 3.10667C14.125 1.38167 12.7333 1.99001 11.55 3.24001Z"
                      stroke="#1C64F2"
                      strokeWidth="1.5"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M10.4082 4.44836C10.7665 6.74836 12.6332 8.5067 14.9499 8.74003"
                      stroke="#1C64F2"
                      strokeWidth="1.5"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3 18.5734H18"
                      stroke="#1C64F2"
                      strokeWidth="1.5"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
              <div className="text-center text-2xl font-semibold text-[#1E429F] 2xl:text-3xl">
                Please pick your preferred lounge
              </div>
              <div ref={dropdownRef} className="w-[600px] !place-self-center">
                <CustomSelect
                  options={lounges}
                  setSelected={setSelectedLounge}
                  selected={selectedLounge}
                  isDropdownOpen={isDropdownOpen}
                  setIsDropdownOpen={setIsDropdownOpen}
                />
                <div className="mt-6 w-[506px] !place-self-center">
                  <Button
                    disabled={selectedLounge && selectedLounge.length <= 0}
                    buttonType="submit"
                    text="Continue"
                    className="!text-lg"
                    onClick={handleSelectedLounge}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {selectedPage === 3 && (
          <div className="flex flex-col items-center gap-6">
            <div className="flex w-full flex-col gap-4 2xl:gap-6">
              <div
                className="flex cursor-pointer justify-center text-center text-sm text-[#1C64F2] underline xl:text-base"
                onClick={() => setSelectedPage(1)}
              >
                <div>
                  Chosen time period -{' '}
                  {startDate ? dayjs(startDate).format('DD-MM-YYYY') : ''} to{' '}
                  {endDate ? dayjs(endDate).format('DD-MM-YYYY') : ''}
                </div>
                <div className="ml-2">
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.55 3.24001L4.70829 10.4817C4.44996 10.7567 4.19996 11.2983 4.14996 11.6733L3.84162 14.3733C3.73329 15.3483 4.43329 16.015 5.39996 15.8483L8.08329 15.39C8.45829 15.3233 8.98329 15.0483 9.24162 14.765L16.0833 7.52334C17.2666 6.27334 17.8 4.84834 15.9583 3.10667C14.125 1.38167 12.7333 1.99001 11.55 3.24001Z"
                      stroke="#1C64F2"
                      strokeWidth="1.5"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M10.4082 4.44836C10.7665 6.74836 12.6332 8.5067 14.9499 8.74003"
                      stroke="#1C64F2"
                      strokeWidth="1.5"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3 18.5734H18"
                      stroke="#1C64F2"
                      strokeWidth="1.5"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
              <div className="text-center text-2xl font-semibold text-[#1E429F] 2xl:text-3xl">
                Please select report type
              </div>
              <div ref={dropdownRef} className="w-[600px] !place-self-center">
                <Dropdown
                  options={reportTypes}
                  setSelectedOption={setSelectedReportType}
                  selectedOption={selectedReportType}
                  isOpen={isDropdownOpen}
                  setIsOpen={setIsDropdownOpen}
                />
                <div className="mt-6 w-[506px] !place-self-center">
                  <Button
                    disabled={!selectedReportType}
                    buttonType="submit"
                    text="Continue"
                    className="!text-lg"
                    onClick={handleSelectedReportType}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {openModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-[rgba(0,0,0,0.85)]">
            <ModalContent
              closeModal={closeModal}
              startDate={startDate}
              endDate={endDate}
              lounges={selectedLounge}
              allLounge={lounges}
              reportType={reportValues[selectedReportType]}
            />
          </div>
        )}
        <div className="text-center text-lg text-[#76A9FA]">
          {selectedPage}/{totalPages}
        </div>
      </div>
    </div>
  );
}
export default MultiTransactions;
